var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-view__box"},[_c('pass'),_c('gift',{staticStyle:{"margin-top":"100px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }